import { IMpnRequest } from "../../../types/data.interface";
import {
  createMpnRequest,
  updatePisRequest,
} from "../../../hooks/usePisRequest";
import { CreateMpnActionTypes, CreateMpnState } from "../states/create/data";
import { AxiosInstance } from "axios";
import { Predicates } from "../../../libraries/predicates/predicates";
import { toast } from "react-toastify";
import { mpnRequestDto } from "./mpnRequestDto";

type onSaveProps = {
  state: CreateMpnState;
  setValues: (...args: any[]) => void;
  axios: AxiosInstance;
  username: any;
  setSearchParams: (...args: any[]) => void;
};

export const onSaveMpn = async ({
  state,
  setValues,
  axios,
  username,
  setSearchParams
}: onSaveProps) => {
  const { mpnRequest, mpnData, composition, requestorInfo } = state;

  const formattedMpnRequest: IMpnRequest = mpnRequestDto(state, username);

  let response: IMpnRequest | null = null;
  setValues(CreateMpnActionTypes.SET_UNSAVED_CHANGES, false);
  setValues(CreateMpnActionTypes.SET_IS_SAVING_OR_SUBMITING, true);

  // No PIS_REQUEST row yet (new MPN or a revision not persisted) -> create; otherwise update it by id
  if (!formattedMpnRequest.id) {
    response = await createMpnRequest({
      requestData: formattedMpnRequest,
      axios,
    });
    //@ts-ignore
    const newPisRequestId: string = response?.pis_request_id ?? null;
    const newId = response?.id;

    setValues(CreateMpnActionTypes.SET_MPN_REQUEST, {
      ...mpnRequest,
      pis_request_id: newPisRequestId,
      id: newId,
    });

    if (!!response) {
      const newUrlParams = new URLSearchParams({
        id: String(newId) ?? "",
        pis_request_id: newPisRequestId,
        revision: formattedMpnRequest.revision,
      });
      setSearchParams(newUrlParams, {
        replace: true,
        state: { shouldShowWarning: "false" },
      });
    }
  } else {
    response = await updatePisRequest({
      id: Number(formattedMpnRequest.id),
      requestData: formattedMpnRequest,
      axios,
    });
  }

  setValues(CreateMpnActionTypes.SET_IS_SAVING_OR_SUBMITING, false);

  if (response) {
    toast.success(
      `MPN Request ${response.pis_request_id} saved successfully!`,
    );
  } else {
    toast.error(
      "An error occurred. It was not possible to save the MPN Request.",
    );
  }

  // if (response?.similar_skus && response?.similar_skus.length)
  //   showToastMessageForSimiliarSkus(response?.similar_skus);
};
